/**
 * @flow
 * @relayHash 22927edf9589a53cf7850a12e6dc62c3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type Reviewers_QueryVariables = {||};
export type Reviewers_QueryResponse = {|
  +reviewers: ?$ReadOnlyArray<?{|
    +id: ?string,
    +name: ?string,
    +title: ?string,
    +profile: ?string,
    +photo: ?string,
    +companyId: ?string,
    +company: ?$ReadOnlyArray<?{|
      +name: ?string,
      +sector: ?string,
      +profile: ?string,
      +yearFounded: ?string,
      +logo: ?string,
    |}>,
  |}>
|};
*/


/*
query Reviewers_Query {
  reviewers {
    id
    name
    title
    profile
    photo
    companyId
    company {
      name
      sector
      profile
      yearFounded
      logo
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "profile",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "photo",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "companyId",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sector",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "yearFounded",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "logo",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "Reviewers_Query",
  "id": null,
  "text": "query Reviewers_Query {\n  reviewers {\n    id\n    name\n    title\n    profile\n    photo\n    companyId\n    company {\n      name\n      sector\n      profile\n      yearFounded\n      logo\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Reviewers_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "reviewers",
        "storageKey": null,
        "args": null,
        "concreteType": "reviewers",
        "plural": true,
        "selections": [
          v0,
          v1,
          v2,
          v3,
          v4,
          v5,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "company",
            "storageKey": null,
            "args": null,
            "concreteType": "reviewCompanies",
            "plural": true,
            "selections": [
              v1,
              v6,
              v3,
              v7,
              v8
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "Reviewers_Query",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "reviewers",
        "storageKey": null,
        "args": null,
        "concreteType": "reviewers",
        "plural": true,
        "selections": [
          v0,
          v1,
          v2,
          v3,
          v4,
          v5,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "company",
            "storageKey": null,
            "args": null,
            "concreteType": "reviewCompanies",
            "plural": true,
            "selections": [
              v1,
              v6,
              v3,
              v7,
              v8,
              v0
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c5b34593b06db2c725de1a34d217b265';
module.exports = node;



// WEBPACK FOOTER //
// ./src/Pages/Experiences/__generated__/Reviewers_Query.graphql.js